/**
 * Refreshes for the cached name lists the settings dialogs share (account
 * summaries, each account's location names and pages). Called by the account
 * and location writes themselves (services/adminApi), so every save path —
 * the Account dialog, a deep-linked Location dialog, the executive dashboard's
 * editor, Platform Admin — refreshes them, not only the screens that remember
 * to invalidate.
 */
import { queryClient } from './queryClient';
import { queryKeys } from './queryKeys';

/**
 * After an account is created, changed, deactivated or restored: its name in
 * the summaries, and the cached account details (e.g. the split-services flag
 * Work Orders reads), which would otherwise stay stale until they expire.
 */
export function refreshAccountNames(): void {
  void queryClient.invalidateQueries({ queryKey: queryKeys.accounts.summaries });
  void queryClient.invalidateQueries({ queryKey: queryKeys.accounts.detailAny });
}

/**
 * After a location is created, renamed, deleted or restored. Every account's
 * location lists are marked stale (a write by location id does not name its
 * account); only the ones on screen refetch.
 */
export function refreshLocationNames(): void {
  void queryClient.invalidateQueries({ queryKey: queryKeys.locations.detailByAnyAccount });
  // The settings location picker's lists of reachable locations carry names too.
  void queryClient.invalidateQueries({ queryKey: queryKeys.myLocationsAll });
}

/**
 * After a location tag is created, renamed or deleted: every cached tag list
 * (per location, account names, account summaries). Tag writes name only the
 * location, and tags change rarely; only the lists on screen refetch.
 */
export function refreshTagNames(): void {
  void queryClient.invalidateQueries({ queryKey: queryKeys.tags.all });
}
